import Vue from "vue";

export const toastState = Vue.observable({ toasts: [] });

let uid = 0;

const VARIANT_MAP = {
  success: "success",
  danger: "error",
  error: "error",
  warning: "warning",
  info: "info",
};

// Accepts the same option names the old $bvToast.toast() calls used
// (title, variant, autoHideDelay) so call sites map 1:1.
export function showToast(message, options = {}) {
  const toast = {
    id: ++uid,
    message,
    title: options.title || null,
    variant: VARIANT_MAP[options.variant] || "warning",
    timeout: options.autoHideDelay || 5000,
  };
  toastState.toasts.unshift(toast);
  return toast.id;
}

export function dismissToast(id) {
  const index = toastState.toasts.findIndex((t) => t.id === id);
  if (index !== -1) toastState.toasts.splice(index, 1);
}
